type AplusCommand = {
  action: string;
  arguments?: unknown[];
};

type UmengEventValue = string | number | boolean | null | undefined;

type TrackPageViewOptions = {
  pathname: string;
  search?: string;
  hash?: string;
  title?: string;
  pageName?: string;
};

declare global {
  interface Window {
    aplus_queue?: AplusCommand[];
  }
}

const UMENG_SCRIPT_ID = 'beacon-aplus';
const UMENG_SCRIPT_VERSION = '203467608';
const DEFAULT_UMENG_APP_KEY = '68900e1ce8f5da3bd4e551cb';

let hasInitializedUmeng = false;

function isBrowser() {
  return typeof window !== 'undefined';
}

function getAplusQueue() {
  window.aplus_queue ??= [];
  return window.aplus_queue;
}

function pushAplusCommand(action: string, ...args: unknown[]) {
  getAplusQueue().push({
    action,
    arguments: args,
  });
}

export function initUmengAnalytics() {
  if (!isBrowser() || hasInitializedUmeng) {
    return;
  }

  hasInitializedUmeng = true;
  pushAplusCommand(
    'aplus.setMetaInfo',
    'appKey',
    import.meta.env.VITE_UMENG_APP_KEY || DEFAULT_UMENG_APP_KEY,
  );
  pushAplusCommand('aplus.setMetaInfo', 'DEBUG', import.meta.env.DEV);
  // React Router 是 SPA，需要关闭自动 PV，改为路由切换时手动发送。
  pushAplusCommand('aplus.setMetaInfo', 'aplus-waiting', 'MAN');

  // 注入script
  if (document.getElementById(UMENG_SCRIPT_ID)) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.id = UMENG_SCRIPT_ID;
  script.src = `https://d.alicdn.com/alilog/mlog/aplus/${UMENG_SCRIPT_VERSION}.js`;

  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
    return;
  }

  document.head.appendChild(script);
}

export function setUmengUser(userId: string | null | undefined) {
  if (!isBrowser()) {
    return;
  }

  pushAplusCommand('aplus.setMetaInfo', '_user_id', userId || '');
}

export function trackUmengPageView({
  pathname,
  search = '',
  hash = '',
  title,
  pageName,
}: TrackPageViewOptions) {
  if (!isBrowser()) {
    return;
  }

  const pageUrl = `${window.location.origin}${pathname}${search}${hash}`;

  pushAplusCommand(
    'aplus.sendPV',
    {
      is_auto: false,
    },
    {
      page_name: pageName || pathname,
      page_title: title || document.title,
      page_url: pageUrl,
    },
  );
}

export function trackUmengEvent(
  eventName: string,
  eventData: Record<string, UmengEventValue> = {},
) {
  if (!isBrowser()) {
    return;
  }

  pushAplusCommand('aplus.record', eventName, 'CLK', eventData);
}

export function getModelAnalyticsEventName(currentModel: string | null | undefined) {
  return `model_3d_${(currentModel || 'unknown').toLowerCase()}`;
}
